<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_notice_on.png" alt="">
          {{$t('noticeSettingTitle')}}
        </h1>
        <span class="info-right">
          <span @click="$router.push({ name: 'NoticeSettingDetail' })" class="btn btn-secondary">{{$t('NoticeSettingDetailStr')}}</span>
          <span @click="$router.push({ name: 'NoticeList' })" class="btn btn-secondary">{{$t('noticeListStr')}}</span>
        </span>

      </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
            <div class="ibox">
                <div class="ibox-content notice-setting">
                    <div class="ibox-title search-box public-body">
                        <div class="">
                            <label class="control-label status-label" for="status">{{ $t('userBtnTile') }}</label>
                        </div>
                        <div class="panel-footer info-add">
                            <span @click="onClickAdd(0)" class="btn btn-success add-public add-public"><i class="fa fa-plus"></i>{{$t('addStr')}}</span>
                        </div>
                    </div>
                    <div class="ibox-content search-resultview">
                        <ul v-if="!checkedUsers">
                             <li class="flex-box fl-between group-item">
                                <span class="group-name">{{$t('notSettingStr')}}</span>
                            </li>
                        </ul>
                        <ul v-else>
                            <li v-for="(userId, user) in checkedUsers" :key="user.id" v-if="getUsers[userId]" class="flex-box fl-between group-item">
                                <div>
                                    <span class="search-userimg">
                                        <img v-if="getUserInfoById(userId).userIcon" :src="getUserInfoById(userId).userIcon" class="img-circle" alt="image" />
                                        <img v-else :src="'static/img/noImage.png'" class="img-circle" alt="image" />
                                    </span>
                                    <div class="search-userinfo">
                                      <span class="search-username">{{ getUserInfoById(userId).userName }}</span>
                                      <span class="search-userdept">{{ getUserInfoById(userId).dept }}</span>
                                    </div>
                                </div>
                                <span class="group-info">
                                    <span class="group-edit">
                                        <span @click="onClickDeleteChecked(userId, 'users')" class="btn btn-danger">{{$t('noticeRelease')}}</span>
                                        <!-- <notice-drop-down :id="userId" :type="'users'"/> -->
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox">
                <div class="ibox-content notice-setting">
                    <div class="ibox-title search-box public-body">
                        <div class="">
                            <label class="control-label status-label" for="status">{{$t('peopleGroupTileType')}}</label>
                        </div>
                        <div class="panel-footer info-add">
                            <span @click="onClickAdd(1)" class="btn btn-success add-public add-public"><i class="fa fa-plus"></i>{{$t('addStr')}}</span>
                        </div>
                    </div>
                    <div class="ibox-content search-resultview">
                         <ul v-if="!checkedGroups">
                             <li class="flex-box fl-between group-item">
                                <span class="group-name">{{$t('notSettingStr')}}</span>
                            </li>
                        </ul>
                        <ul v-else>
                            <li @click="onClickGroup(getGroupsInfoByIds[groupId], groupId)" v-for="(groupId, group) in checkedGroups" :key="group.id" v-if="getGroupsInfoByIds[groupId]" class="flex-box fl-between group-item cursor">
                                <span class="group-name">{{ getGroupsInfoByIds[groupId].groupName }}</span>
                                <span class="group-info">{{$t('memberStr')}}:
                                    <span class="menber-count">({{ Object.keys(getGroupsInfoByIds[groupId].members).length }})</span>
                                    <span class="group-edit">
                                        <span @click.prevent.stop="onClickDeleteChecked(groupId, 'groups')" class="btn btn-danger">{{$t('noticeRelease')}}</span>
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox">
                <div class="ibox-content notice-setting">
                    <div class="ibox-title search-box public-body">
                        <div class="">
                            <label class="control-label status-label" for="status">{{ $t('organizationLabelStr') }}</label>
                        </div>
                        <div class="panel-footer info-add">
                            <span @click="onClickAdd(2)" class="btn btn-success add-public add-public"><i class="fa fa-plus"></i>{{$t('addStr')}}</span>
                        </div>
                    </div>
                    <div class="ibox-content search-resultview">
                         <ul v-if="!checkedGroups">
                             <li class="flex-box fl-between group-item">
                                <span class="group-name">{{$t('notSettingStr')}}</span>
                            </li>
                        </ul>
                        <ul v-else>
                            <li @click="onClickGroup(getOrganizationInfoByIds[groupId], groupId)" v-for="(groupId, group) in checkedOrganizations" :key="group.id" v-if="getOrganizationInfoByIds.hasOwnProperty(groupId)" class="flex-box fl-between group-item cursor">
                                <span class="group-name">{{ getOrganizationPathName[groupId] }}</span>
                                <span class="group-info">{{$t('memberStr')}}:
                                    <span class="menber-count">({{ Object.keys(getOrganizationInfoByIds[groupId].members || {}).length }})</span>
                                    <span class="group-edit">
                                        <span @click.prevent.stop="onClickDeleteChecked(groupId, 'organizations')" class="btn btn-danger">{{$t('noticeRelease')}}</span>
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox-child">
                <div class="row okr-regist-btnset">
                    <div class="col-4"><button @click="onClickSave" class="btn btn-success block m-b">{{$t('saveStr')}}</button></div>
                    <div class="col-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                </div>
            </div>
        </section>
        </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <!-- グループ詳細表示 -->
          <section class="inner-wrap">
            <div  v-if="group == true" class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  {{ this.targetGroup.groupName }}
                </span>
                <span class="info-right">
                  <span class="group-info">{{$t('memberStr')}}: ({{Object.keys(this.targetGroup.members || {}).length}})</span>
                </span>
              </div>
              <template>
              <div class="ibox-child">
                <div class="search-resultview">
                  <ul>
                    <li v-for="user in getUsersInfo" :key="user.id"><label>
                      <span class="search-userimg">
                        <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                        <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                      </span>
                      <div class="search-userinfo">
                        <span class="search-username">{{ user.userInfo.userName }}</span>
                        <span class="search-userdept">{{ user.userInfo.dept }}</span>
                      </div>
                    </label></li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
          <!-- /グループ詳細表示 -->
          <!-- 通知対象検索 -->
          <div v-if="group == false" class="s-inner-wrap">
            <div class="ibox-title flex-box fl-between ibox-detail-header">
              <span class="info-menu">{{$t('noticeSettingTitle')}}</span>
              <span class="info-right"></span>
            </div>
            <div class="ibox">
                <div class="ib-sub-content">
                    <!-- ユーザー検索ボックス-チェックボックス型 -->
                  <div class="tabs-container">
                      <div class="ibox-title search-box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserNameOrGroupNameOrOrganizationNameStr')">
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="ib-sub-content">
                        <b-tabs v-model="tabIndex">
                          <b-tab :title="$t('userBtnTile')" active class="tab-pane search-resultview">
                            <ul v-if="searchText == ''">
                              <li><label>{{$t('checkUserStrType')}}</label></li>
                              <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                                <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId"><label>
                                  <input type="checkbox" v-model="checkedUsers" :value="user.userId" class="checkbox public-check">
                                  <span class="search-userimg">
                                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="search-userinfo">
                                    <span class="search-username">{{ user.userInfo.userName }}</span>
                                    <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                  </div>
                                  <span class="check-mark"></span>
                                </label></li>
                            </ul>
                            <ul v-else>
                              <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                                <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== getUserId"><label>
                                  <input type="checkbox" v-model="checkedUsers" :value="key" class="checkbox public-check">
                                  <span class="search-userimg">
                                    <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                    <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                  </span>
                                  <div class="search-userinfo">
                                    <span class="search-username">{{ user.userInfo.userName }}</span>
                                    <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                  </div>
                                  <span class="check-mark"></span>
                                </label></li>
                            </ul>
                          </b-tab>
                            <b-tab :title="$t('peopleGroupTileType')" class="tab-pane search-resultview">
                              <br>
                                <ul v-if="searchText == ''">
                                  <!-- <div > -->
                                    <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" v-if="group && Object.values(getGroupsBySearchText)[0] && group.groupName  && group.members && group.ownerId"><label>
                                        <input type="checkbox" v-model="checkedGroups" :value="key" class="checkbox public-check">
                                        <div id="group1" class="ibox-child flex-box fl-between group-item">
                                          <span v-if="group.ownerId == getUserId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                                          <span class="group-name">{{group.groupName}}</span>
                                          <span class="group-info">{{$t('memberStr')}}:
                                            <span class="menber-count">({{Object.keys(group.members || {}).length}})</span>
                                          </span>
                                        </div>
                                        <span class="check-mark"></span>
                                    </label></li>
                                  <!-- </div> -->
                                </ul>
                                <ul v-else>
                                  <li v-if="Object.keys(this.getGroupsBySearchText).length === 0"><label>{{$t('notFoundGroupNameStr')}}</label></li>
                                    <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" v-if="group && Object.values(getGroupsBySearchText)[0] && group.groupName && group.members && group.ownerId"><label>
                                        <input type="checkbox" v-model="checkedGroups" :value="key" class="checkbox public-check">
                                        <div id="group1" class="ibox-child flex-box fl-between group-item">
                                          <span v-if="group.ownerId == getUserId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                                          <span class="group-name">{{group.groupName}}</span>
                                          <span class="group-info">{{$t('memberStr')}}:
                                            <span class="menber-count">({{Object.keys(group.members || {}).length}})</span>
                                          </span>
                                        </div>
                                        <span class="check-mark"></span>
                                    </label></li>
                                </ul>
                            </b-tab>
                            <!--organization-->
                            <b-tab :title="$t('organizationLabelStr')" class="tab-pane search-resultview">
                              <br>
                                <ul v-if="searchText == ''">
                                    <organization-item
                                    :userVisibleOrganization="true"
                                    :checkedOrganizations="checkedOrganizations"
                                    :OrganizaitonPath="getOpens"
                                    @onClickOrganization="ocClickOrganizationCheck"></organization-item>
                                </ul>
                                <ul v-else>
                                  <li v-if="Object.keys(this.getOrganizationsBySearchText).length === 0"><label>{{$t('notFoundOrganizationNameStr')}}</label></li>
                                  <organization-item
                                  :checkedOrganizations="checkedOrganizations"
                                  :OrganizaitonPath="getSearchOpens"
                                  @onClickOrganization="ocClickOrganizationCheck"></organization-item>
                                </ul>
                            </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                  <!-- /ユーザー検索ボックス-チェックボックス型 -->
              </div>
          </div>
          <!-- /通知対象検索  -->
        </div>
      </section>
    </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NoticeItem from '@/components/Notice/NoticeItem'
import NoticeDropDown from '@/components/Notice/NoticeDropDown'
import OrganizationItem from '@/components/People/OrganizationItem'
export default {
  name: 'NoticeSetting',
  components: {
    NoticeItem,
    NoticeDropDown,
    OrganizationItem
  },
  data: function () {
    return {
      tag: 'progress',
      open: false,
      searchText: '',
      tabIndex: 0,
      group: false,

      targetGroupId: '',
      targetGroup: {
        members: {},
        groupName: ''
      },
      //   users: {},
      checkedUsers: [],
      //   groups: {},
      checkedGroups: [],
      // organizations: {},
      checkedOrganizations: [],

      oldFollowingUsers: [],
      oldFollowingGroups: [],
      oldFollowingOrganizations: []
    }
  },
  mounted: function () {
    if (this.getUserFollowing && this.getUserFollowing.users) {
      this.checkedUsers = Object.keys(this.getUserFollowing.users)
      this.oldFollowingUsers = Object.keys(this.getUserFollowing.users)
    }
    // 通知設定のグループは組織も内包してるのでgroupと組織に分ける
    let groups = []
    let organizations = []
    if (this.getUserFollowing && this.getUserFollowing.groups) {
      const allGroups = this.getGroups
      Object.keys(this.getUserFollowing.groups).map(x => {
        if (allGroups[x].hasOwnProperty('isOrganization')) {
          organizations.push(x)
        } else {
          groups.push(x)
        }
      })
    }
    this.checkedGroups = groups
    this.oldFollowingGroups = groups.map(x => x)
    this.checkedOrganizations = organizations
    this.oldFollowingOrganizations = organizations
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'NoticeSetting'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupById',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById',
      'getUsers'
    ]),
    ...mapGetters('organizations/', [
      'getOnlyOrganizationsByText',
      'getOpenOrganization',
      'getOnlyOrganizationsByIds',
      'getOrganizationNameKeys'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getOrganizationPathName: function () {
      return this.getOrganizationNameKeys
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getOrganizationsBySearchText: function () {
      let Organizations = this.getOnlyOrganizationsByIds(Object.keys(this.getGroups))['node']
      if (this.searchText.length === 0) {
        return Organizations
      } else {
        return this.getOnlyOrganizationsByText(this.searchText)
      }
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getUserFollowing: function () {
      console.log('getCurrentUser', this.getCurrentUser)
      console.log('getCurrentUser', this.getCurrentUser.following)
      return this.getCurrentUser.following
    },
    getUsersInfo: function () {
      return this.getUsersByIds(Object.keys(this.targetGroup.members || {}))
    },
    getGroupsInfoByIds: function () {
      return this.getGroupsByIds(this.checkedGroups)
    },
    getOrganizationInfoByIds: function () {
      return this.getGroupsByIds(this.checkedOrganizations)
    },
    getOpens: function () {
      let searchOpens = {roots: [], node: []}
      let getOrganization = {}
      for (let x of this.checkedOrganizations) {
        if (this.getGroupById(x).hasOwnProperty('isOrganization')) {
          getOrganization[x] = this.getOrganizationInfoByIds[x]
        }
      }
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(getOrganization)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(getOrganization)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      // {a:[],b:[],c:[]}
      return searchOpens
    },
    getSearchOpens: function () {
      let searchOpens = {roots: [], node: []}
      let getOrganization = {}
      for (let x of Object.keys(this.getOrganizationsBySearchText)) {
        if (this.getGroupById(x).hasOwnProperty('isOrganization')) {
          getOrganization[x] = this.getOrganizationsBySearchText[x]
        }
      }
      searchOpens['roots'] = Object.keys(this.getOpenOrganization(Object.keys(getOrganization)))
      for (let ser of Object.values(this.getOpenOrganization(Object.keys(getOrganization)))) {
        searchOpens['node'] = searchOpens['node'].concat(ser['node'])
      }
      // {a:[],b:[],c:[]}
      return searchOpens
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('users', {
      setFollowingUsers: 'SET_FOLLOWING_USERS'
    }),
    ...mapActions('groups/', {
      setFollowingGroups: 'SET_FOLLOWING_GROUPS'
    }),
    onClickAdd: function (num) {
      if (this.open && this.tabIndex === num && !this.group) {
        this.open = false
      } else {
        this.open = true
      }
      console.log(num)
      this.group = false
      this.tabIndex = num
    },
    onClickGroup: function (group, id) {
      this.targetGroup = group
      this.targetGroupId = id
      console.log(this.targetGroup)
      console.log(this.targetGroupId)
      this.group = true
      if (!this.open) {
        this.open = true
      }
    },
    ocClickOrganizationCheck: function (groupId) {
      let checkedOrganizationIndex = this.checkedOrganizations.indexOf(groupId)
      if (checkedOrganizationIndex >= 0) {
        this.checkedOrganizations.splice(checkedOrganizationIndex, 1)
      } else {
        this.checkedOrganizations.push(groupId)
      }
    },
    onClickSave: function () {
      console.log('-----', this.oldFollowingUsers)
      console.log('---------', this.checkedUsers)
      const $t = this.$t
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('receivePopupStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          // okが押下されたら
          if (this.checkedUsers.length > 0) {
            for (let checkedUser of this.checkedUsers) {
              this.setVisit(checkedUser)
            }
          }
          let valueUser = {
            'oldFollowingUsers': this.oldFollowingUsers,
            'users': this.checkedUsers
          }
          this.setFollowingUsers(valueUser)
          let valueGroup = {
            'oldFollowingGroups': this.oldFollowingGroups,
            'groups': this.checkedGroups
          }
          this.setFollowingGroups(valueGroup)
          let valueOrganization = {
            'oldFollowingGroups': this.oldFollowingOrganizations,
            'groups': this.checkedOrganizations
          }
          this.setFollowingGroups(valueOrganization)
          this.oldFollowingUsers = [...this.checkedUsers]
          this.oldFollowingGroups = [...this.checkedGroups]
          this.oldFollowingOrganizations = [...this.checkedOrganizations]
          this.$swal({
            title: $t('compAddNoticeSettingStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
          this.open = false
        } else {
          // cancelが押下されたら
          console.log('false')
        }
      })
    },
    onClickCancel: function () {
      this.checkedUsers = [...this.oldFollowingUsers]
      this.checkedGroups = [...this.oldFollowingGroups]
      this.checkedOrganizations = [...this.oldFollowingOrganizations]
    },
    onClickDeleteChecked: function (Id, type) {
      if (type === 'users') {
        let targetIndex = this.checkedUsers.indexOf(Id)
        this.checkedUsers.splice(targetIndex, 1)
      } else if (type === 'groups') {
        let targetIndex = this.checkedGroups.indexOf(Id)
        this.checkedGroups.splice(targetIndex, 1)
      } else if (type === 'organizations') {
        let targetIndex = this.checkedOrganizations.indexOf(Id)
        this.checkedOrganizations.splice(targetIndex, 1)
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/notice/NoticeSetting.vue